import React from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';

const Mentors = () => {
    return (
        <>
            <div className='mentor'>
                <div className='max-width'>
                    <div className='mHead'>
                        Become a mentor
                    </div>
                    <div className='mp'>
                        The purpose of mentoring is to connect an individual who has a lot of
                        knowledge and experience with someone who hasn’t gained the same
                        knowledge or experience—yet.
                    </div>
                    <div className='mImg'>
                        <img src='mentorimg.png' alt='img' />
                    </div>
                    <div className='mbtn'>
                        <Button className='btn1'>Get started</Button>
                        <Button className='btn2'>Learn more</Button>
                    </div>
                    <div className='mHead Mhead'>
                        Our mentor’s
                    </div>
                    <Container>
                        <Row>
                            <Col>
                                <div className='ocard o1'>
                                    <div className='ocenter'>
                                        <div className='ocircle'>
                                            <img src='saurabh.png' alt='' />
                                        </div>
                                    </div>
                                    <h2>Saurabh Patel</h2>
                                </div>
                            </Col>

                            <Col>
                                <div className='ocard o2'>
                                    <div className='ocenter'>
                                        <div className='ocircle'>
                                            <img src='nishant.png' alt='' />
                                        </div>
                                    </div>
                                    <h2>Nishant Kumar</h2>
                                </div>
                            </Col>

                            <Col>
                                <div className='ocard o3'>
                                    <div className='ocenter'>
                                        <div className='ocircle'>
                                            <img src='anmol.png' alt='' />
                                        </div>
                                    </div>
                                    <h2>Anmol Raj</h2>
                                </div>
                            </Col>

                            <Col>
                                <div className='ocard o4'>
                                    <div className='ocenter'>
                                        <div className='ocircle'>
                                            <img src='ayush.png' alt='' />
                                        </div>
                                    </div>
                                    <h2>Ayush Sharma</h2>
                                </div>
                            </Col>

                        </Row>
                    </Container>
                    <div className='mbtn'>
                        <Button className='btn3'>View all</Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Mentors;